<ng-container *ngIf="product.name">
  <div
    class="fixed top-16 left-0 z-10 w-full bg-white shadow-sm"
    [@showTopBar]="isShowTopBar ? 'show' : 'hide'">
    <div class="top-bar-content mx-auto flex gap-3" *ngIf="isShowTopBar">
      <ul
        class="navigation scroll-hidden flex flex-1 overflow-x-scroll text-sm">
        <li
          class="link h-full cursor-pointer border-b-2 p-4"
          [ngClass]="
            activeNavigation == 'description'
              ? 'border-primary-md-dark'
              : 'border-transparent'
          "
          (click)="onScrollToElem(detailContainer)">
          Detail
        </li>
        <li
          class="link h-full cursor-pointer border-b-2 p-4"
          [ngClass]="
            activeNavigation == 'review'
              ? 'border-primary-md-dark'
              : 'border-transparent'
          "
          (click)="onScrollToElem(reviewContainer)">
          Reviews
        </li>
        <li
          class="link h-full cursor-pointer border-b-2 p-4"
          [ngClass]="
            activeNavigation == 'discussion'
              ? 'border-primary-md-dark'
              : 'border-transparent'
          "
          (click)="onScrollToElem(discussionContainer)">
          Discussions
        </li>
        <li
          class="link h-full cursor-pointer border-b-2 p-4"
          [ngClass]="
            activeNavigation == 'recommendation'
              ? 'border-primary-md-dark'
              : 'border-transparent'
          "
          (click)="onScrollToElem(recommendationContainer)">
          Recommendation
        </li>
      </ul>
    </div>
  </div>
  <main class="product mx-auto space-y-3 bg-slate-100" *ngIf="product.name">
    <section class="product-preview gap-10 space-y-3 bg-white" #detailContainer>
      <div class="product-assets relative">
        <swiper
          class="product-image w-full"
          [config]="config"
          *ngIf="productDetail && productDetail.images.length > 0">
          <ng-template
            swiperSlide
            *ngFor="let productImage of productDetail.images">
            <img
              class="aspect-square w-full"
              [src]="productImage.medium.path"
              [alt]="product ? product.name : 'product image'" />
          </ng-template>
        </swiper>
        <div class="absolute top-3 right-3 z-10" *ngIf="product.has_vmakeup">
          <img
            class="aspect-square w-24 cursor-pointer transition duration-300 ease-in-out hover:scale-105"
            src="assets/images/tryon.webp"
            alt="try on"
            [routerLink]="" />
        </div>
      </div>
      <div class="product-info flex-1 space-y-3 bg-white p-3" *ngIf="product">
        <div class="product-price flex items-center gap-3 text-2xl font-medium">
          <div class="flex-1">
            <div
              class="discount text-sm text-gray-500 line-through"
              *ngIf="
                (selectedVariant &&
                  selectedVariant.unit_price != selectedVariant.actual_price) ||
                (!selectedVariant &&
                  product.max_price != product.actual_max_price)
              ">
              <div class="actual_price text-base text-gray-600 line-through">
                {{
                  selectedVariant && selectedVariant.actual_price
                    ? (selectedVariant.actual_price | fcCurrency)
                    : (product.actual_max_price | fcCurrency)
                }}
              </div>
            </div>
            <div class="price text-red-500">
              {{
                selectedVariant && selectedVariant.unit_price
                  ? (selectedVariant.unit_price | fcCurrency)
                  : (product.max_price | fcCurrency)
              }}
              <span
                class="text-xl text-red-700"
                *ngIf="
                  (selectedVariant &&
                    selectedVariant.unit_price !=
                      selectedVariant.actual_price) ||
                  (!selectedVariant &&
                    product.max_price != product.actual_max_price)
                ">
                ({{
                  selectedVariant && selectedVariant.discountPercentage
                    ? selectedVariant.discountPercentage
                    : product.discount_percentage
                }}% saved)
              </span>
            </div>
          </div>
          <div class="favorite flex gap-3">
            <button
              type="button"
              class="btn-share h-8 w-8 items-center justify-center rounded-full border border-primary-light p-1 text-sm"
              (click)="onShare()">
              <!-- note -->
              <fa-icon
                [icon]="faShare"
                [ngClass]="{
                  'text-primary-md-dark': true,
                  'text-red-200': false
                }">
              </fa-icon>
            </button>
            <button
              class="btn-wishlist h-8 w-8 items-center justify-center rounded-full border border-red-500 p-1 text-sm"
              (click)="onAddToWishlist()">
              <!-- note -->
              <fa-icon
                [icon]="faHeart"
                [ngClass]="{
                  'text-red-500': product.on_wishlist,
                  'text-red-200': !product.on_wishlist
                }">
              </fa-icon>
            </button>
          </div>
        </div>
        <div class="product-title mb-3">
          <h2 class="product-name text-xl font-semibold text-primary-darkest">
            {{ product.name }}
          </h2>
          <div class="product-sum flex gap-3 py-3 text-sm">
            <div class="products-sold rounded-lg py-1">
              Sold
              {{
                productDetail.sold_quantity ? productDetail.sold_quantity : 0
              }}
            </div>
            <div
              class="product-rating flex items-center gap-1 rounded-lg border py-1 px-3">
              <fa-icon [icon]="faStar" class="text-yellow-500"></fa-icon>
              <span>
                {{ product.average_rating || 0 | number }}
              </span>
            </div>
            <div class="total-review rounded-lg border py-1 px-3">
              <fa-icon class="text-gray-500" [icon]="faCommentAlt"></fa-icon>
              {{ productDetail.total_review ? productDetail.total_review : 0 }}
            </div>
          </div>
        </div>
        <div class="product-spec">
          <div class="product-spec__detail grid-cols-12 space-y-3">
            <div class="specification col-span-12 space-y-3 text-sm">
              <div class="spec-item grid grid-cols-12">
                <div class="label col-span-5">Category</div>
                <div class="value col-span-7">{{ product.category_name }}</div>
              </div>
              <div class="spec-item grid grid-cols-12">
                <div class="label col-span-5">Brand</div>
                <div class="value col-span-7">{{ product.brand_name }}</div>
              </div>
              <!-- <div class="spec-item grid grid-cols-12">
              <div class="label col-span-5">Suitable Skin Type</div>
              <div class="value col-span-7">
                <span *ngIf="productDetail.suitableSkinTypes.length < 1"
                  >-</span
                >
                <span
                  class="comma"
                  *ngFor="let skinType of productDetail.suitableSkinTypes"
                  >{{ skinType.skin_type_name }}</span
                >
              </div>
            </div>
            <div class="spec-item grid grid-cols-12">
              <div class="label col-span-5">Suitable Skin Problem</div>
              <div class="value col-span-7">
                <span *ngIf="productDetail.suitableSkinProblems.length < 1"
                  >-</span
                >
                <span
                  class="comma"
                  *ngFor="let skinProblem of productDetail.suitableSkinProblems"
                  >{{ skinProblem.skin_problem_name }}</span
                >
              </div>
            </div> -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="product-shop bg-white p-3">
      <div class="shop-info flex w-full items-center justify-between">
        <div class="flex flex-1 items-start gap-3">
          <div class="shop-img h-14 w-14 rounded-full bg-primary-md-dark">
            <img [src]="shop?.logo_path" [alt]="shop?.name" />
          </div>
          <div class="shop-detail flex-1">
            <h4 class="shop-name text-lg font-semibold text-primary-darkest">
              {{ shop?.name }}
            </h4>
            <p class="shop-total-product text-xs font-light">
              Total Products:
              <span class="font-medium text-primary-darkest">{{
                shop?.total_product
              }}</span>
            </p>
          </div>
        </div>
        <button
          type="button"
          class="rounded-md border border-primary-md-dark py-1 px-6 text-sm text-primary-md-dark"
          (click)="navigateToShop()">
          Visit Shop
        </button>
      </div>
    </section>
    <section class="space-y-5 bg-white p-3" #detailBoxContainer>
      <div class="product-desc">
        <h3 class="mb-3 font-medium uppercase text-primary-darkest">
          Product Description
        </h3>
        <div class="product-desc__detail">
          <p>{{ product.short_description }}</p>
          <p
            class="font-bold text-primary-md-dark"
            (click)="producDescriptionDrawer.toggle()">
            Baca Selengkapnya
          </p>
        </div>
      </div>
      <div class="product-brochure" *ngIf="brochures.length">
        <h3 class="mb-3 font-medium uppercase text-primary-darkest">
          Product Brochure
        </h3>
        <div class="brochure my-3">
          <img
            class="mx-auto"
            [src]="brochures[0].path"
            alt="brochure"
            loading="lazy" />
        </div>
        <div
          class="btn-see-more-container text-center"
          *ngIf="brochures.length > 1">
          <button
            type="button"
            class="mx-auto rounded-md border border-primary-md-dark bg-white py-1 px-4 text-primary-md-dark"
            (click)="producDescriptionDrawer.toggle()">
            Show more
          </button>
        </div>
      </div>
    </section>
    <section class="bg-white p-3" #reviewContainer>
      <div class="title mb-3 flex items-center justify-between">
        <h3 class="font-medium uppercase text-primary-darkest">
          Review ({{ productMobileReview.totalReviews }})
        </h3>
        <span
          (click)="productReviewDrawer.toggle()"
          class="font-medium text-primary-md-dark"
          >See more</span
        >
      </div>
      <div
        *ngIf="productMobileReview.totalReviews < 1"
        class="empty-data py-3 text-center">
        <img
          src="assets/images/product/empty-review-illust.png"
          alt="no review"
          class="illust mx-auto mb-3 w-full max-w-[200px]" />
        <div class="caption text-lg font-medium text-primary-darkest">
          No reviews yet
        </div>
        <div class="subcaption text-sm text-primary-md-dark">
          Be the first one to review this product? why not?
        </div>
      </div>
    </section>
    <section class="bg-white p-3" #discussionContainer>
      <div class="title mb-3 flex items-center justify-between">
        <h3 class="font-medium uppercase text-primary-darkest">
          Discussions ({{ productMobileDiscussion.totalDiscussion }})
        </h3>
        <span
          (click)="productDiscussionDrawer.toggle()"
          class="font-medium text-primary-md-dark"
          >See more</span
        >
      </div>
      <div
        *ngIf="productMobileDiscussion.totalDiscussion < 1"
        class="empty-data py-3 text-center">
        <img
          src="assets/images/product/empty-discussion-illust.png"
          alt="no discussion"
          class="illust mx-auto mb-3 w-full max-w-[200px]" />
        <div class="caption text-lg font-medium text-primary-darkest">
          Let us know what you think.
        </div>
        <div class="subcaption text-sm text-primary-md-dark">
          Any question? Discuss with sellers or users here now.
        </div>
      </div>
    </section>
    <section class="bg-white p-3" #recommendationContainer>
      <h3 class="mb-3 font-medium uppercase text-primary-darkest">
        Recomended for you
      </h3>
      <div>
        <swiper
          class="recommended-by-similiar-product"
          [config]="recommendedConfig">
          <ng-template swiperSlide *ngFor="let product of recomendedProducts">
            <fc-product-item [product]="product"></fc-product-item>
          </ng-template>
        </swiper>
      </div>
    </section>
  </main>
  <div
    class="fixed left-0 bottom-0 z-10 w-full border-t bg-white"
    *ngIf="product.name">
    <div class="flex w-full gap-3 p-3">
      <ng-container *ngIf="productDetail && productDetail.images.length > 0">
        <div
          class="product-image cursor`-pointer h-10 w-10 overflow-hidden border border-primary-md-dark">
          <img
            class="h-10 w-10"
            [src]="productDetail.images[0].extra_small.path"
            [alt]="product ? product.name : 'product image'" />
        </div>
      </ng-container>
      <div class="product-info flex-1 truncate">
        <div class="product-name flex text-sm">
          <div class="name flex-1 truncate text-sm">{{ product.name }}</div>
          <div class="variant" *ngIf="selectedVariant">
            ({{ selectedVariant.variant_name_1 }}
            <span *ngIf="selectedVariant.variant_name_2">-</span>
            {{ selectedVariant.variant_name_2 }})
          </div>
        </div>
        <div class="product-price text-xs">
          <span
            class="discount text-[10px] line-through"
            *ngIf="
              (selectedVariant &&
                selectedVariant.unit_price != selectedVariant.actual_price) ||
              (!selectedVariant &&
                product.max_price != product.actual_max_price)
            ">
            {{
              selectedVariant && selectedVariant.actual_price
                ? (selectedVariant.actual_price | fcCurrency)
                : (product.actual_max_price | fcCurrency)
            }}
          </span>
          <span class="text-red-500">
            {{
              selectedVariant && selectedVariant.unit_price
                ? (selectedVariant.unit_price | fcCurrency)
                : (product.max_price | fcCurrency)
            }}
          </span>
          <span class="quantity">x{{ cartForm.value.quantity }}</span>
        </div>
      </div>
      <div>
        <button
          type="button"
          class="product-cart__btn flex w-full items-center gap-1 rounded-md border border-red-500 py-1 px-4 text-red-500"
          (click)="cartFormDrawer.toggle()">
          <fa-icon [icon]="faPlus"></fa-icon>
          <fa-icon [icon]="faShoppingCart"></fa-icon>
        </button>
      </div>
    </div>
  </div>
  <fc-drawer #producDescriptionDrawer title="Description">
    <fc-mobile-product-description
      *ngIf="product"
      [product]="product"
      [brochures]="brochures"></fc-mobile-product-description>
  </fc-drawer>
  <fc-drawer
    #productReviewDrawer
    [title]="'Review ' + '(' + productMobileReview.totalReviews + ')'">
    <fc-mobile-product-review
      #productMobileReview
      [slug]="slug"></fc-mobile-product-review>
  </fc-drawer>
  <fc-drawer
    #productDiscussionDrawer
    [title]="
      'Discussion ' + '(' + productMobileDiscussion.totalDiscussion + ')'
    ">
    <fc-mobile-product-discussion
      #productMobileDiscussion
      [slug]="slug"
      [productId]="product.id"></fc-mobile-product-discussion>
  </fc-drawer>
  <fc-drawer #cartFormDrawer title="Atur Pembelian">
    <div class="cart-form w-full space-y-3 p-3" *ngIf="product.name">
      <div class="product-variant-group" *ngIf="variantTier1.name">
        <div class="variant-name mb-2 text-primary-md-dark">
          {{ variantTier1.name }}
        </div>
        <div class="variant-list flex flex-wrap items-center gap-3">
          <button
            type="button"
            *ngFor="let variant of variantTier1.variants"
            class="rounded-md border border-primary-dark py-1 px-5"
            [ngClass]="[
              selectedVariantTier1Name == variant.variant_name_1
                ? 'bg-primary-lightest'
                : '',
              checkAvailableVariantTier1(variant.variant_name_1)
                ? ''
                : 'disabled noselect'
            ]"
            (click)="onSelectVariantTier1(variant)">
            {{ variant.variant_name_1 }}
          </button>
        </div>
      </div>
      <div class="product-variant-group" *ngIf="variantTier2.name">
        <div class="variant-name mb-2 text-primary-md-dark">
          {{ variantTier2.name }}
        </div>
        <div class="variant-list flex flex-wrap items-center gap-3">
          <button
            type="button"
            *ngFor="let variant of variantTier2.variants"
            class="rounded-md border border-primary-dark py-1 px-5"
            [ngClass]="[
              selectedVariantTier1Name == variant.variant_name_2
                ? 'bg-primary-lightest'
                : '',
              checkAvailableVariantTier2(variant.variant_name_2)
                ? ''
                : 'disabled noselect'
            ]"
            (click)="onSelectVariantTier2(variant)">
            {{ variant.variant_name_2 }}
          </button>
        </div>
      </div>
      <div class="product-quantity space-y-2">
        <form
          class="product-quantity-form flex items-center gap-3"
          [formGroup]="cartForm">
          <button
            type="button"
            class="flex h-10 w-10 items-center justify-center rounded-full bg-primary-main text-2xl font-medium text-primary-darkest"
            [ngClass]="{
              'opacity-50': cartForm.get('quantity')?.value <= 1
            }"
            (click)="onChangeQuantity(false)"
            [disabled]="cartForm.get('quantity')?.value <= 1">
            -
          </button>
          <div class="flex-1">
            <p-inputNumber
              class="w-full"
              styleClass="product-quantity-form__input [&>input]:w-full [&>input]:text-center [&>input]:border-none [&>input]:shadow-none text-center font-medium text-primary-darkest"
              mode="decimal"
              [min]="1"
              formControlName="quantity">
            </p-inputNumber>
          </div>
          <button
            type="button"
            class="flex h-10 w-10 items-center justify-center rounded-full bg-primary-main text-2xl font-medium text-primary-darkest"
            [ngClass]="{
              'opacity-50':
                cartForm.get('quantity')?.value >= product.remaining_stock
            }"
            [disabled]="
              cartForm.get('quantity')?.value >= product.remaining_stock
            "
            (click)="onChangeQuantity(true)">
            +
          </button>
        </form>
        <label for="quantity" class="text-xs">
          Available {{ product.remaining_stock || 0 }} pcs
        </label>
        <div class="flex items-end justify-between">
          <h4 class="text-lg text-gray-500">Subtotal</h4>
          <span class="text-2xl font-medium">
            {{
              selectedVariant && selectedVariant.unit_price
                ? ((selectedVariant.unit_price || 0) * cartForm.value.quantity
                  | fcCurrency)
                : (product.max_price * cartForm.value.quantity | fcCurrency)
            }}
          </span>
        </div>
      </div>
      <div class="product-cart space-y-3">
        <button
          type="button"
          class="product-cart__btn flex w-full items-center justify-center gap-2 rounded-md bg-red-500 py-1 px-4 text-white"
          (click)="cartFormDrawer.toggle(); onAddToCart(false, true)">
          <fa-icon [icon]="faShoppingCart"></fa-icon>
          Add to Cart
        </button>
        <button
          type="button"
          class="product-cart__btn w-full rounded-md border border-red-500 py-1 px-4 text-red-500"
          (click)="cartFormDrawer.toggle(); onAddToCart(true, true)">
          Buy Now
        </button>
      </div>
    </div>
  </fc-drawer>
</ng-container>

<div class="product__loading" *ngIf="!product.name">
  <p-skeleton styleClass="!h-auto aspect-square w-full"></p-skeleton>
  <div class="mt-3">
    <p-skeleton class="w-full" height="2rem"></p-skeleton>
  </div>
</div>
